export default __webpack_public_path__ + "static/media/3.dd7ac3bf.jpg";